import React, { useState } from "react";
import { motion } from "framer-motion";
import { Target, Rocket } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const VisionSection = () => {
    const [activeTab, setActiveTab] = useState("mission");

    return (
        <section className="relative py-20">
            <div className="absolute inset-0">
                {[...Array(40)].map((_, i) => (
                    <motion.div
                        key={i}
                        animate={{
                            y: [0, -100, 0],
                            x: [0, Math.sin(i) * 50, 0],
                            opacity: [0.1, 0.3, 0.1],
                        }}
                        transition={{
                            duration: 10 + i,
                            repeat: Infinity,
                            delay: i * 0.5,
                            ease: "linear"
                        }}
                        className="absolute w-32 h-32 rounded-full blur-xl bg-gradient-to-r from-blue-500/5 to-cyan-500/5"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                    />
                ))}
            </div>

            <div className="relative z-10 max-w-6xl mx-auto px-4">
                <AnimatedSection delay={0.2}>
                    <div className="text-center mb-12">
                        <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6">
                            Notre<span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">Vision</span>
                        </h2>

                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            Redéfinir les possibilités de l'innovation technologique
                        </p>
                    </div>
                </AnimatedSection>

                <AnimatedSection delay={0.3}>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                        <button
                            onClick={() => setActiveTab("mission")}
                            className={`px-8 py-4 rounded-xl cursor-pointer font-semibold text-lg transition-all duration-300 ${activeTab === "mission"
                                ? "bg-gradient-to-r from-blue-500 via-cyan-500 to-blue-800  text-white shadow-lg"
                                : "bg-gray-900/50 backdrop-blur-sm text-gray-300 border border-gray-700 hover:border-blue-500/30"
                                }`}
                        >
                            <div className="flex items-center gap-3">
                                Notre Mission
                            </div>
                        </button>

                        <button
                            onClick={() => setActiveTab("ambition")}
                            className={`px-8 py-4 rounded-xl font-semibold cursor-pointer text-lg transition-all duration-300 ${activeTab === "ambition"
                                ? "bg-gradient-to-r from-purple-500 to-blue-800 text-white shadow-lg"
                                : "bg-gray-900/50 backdrop-blur-sm text-gray-300 border border-gray-700 hover:border-purple-500/30"
                                }`}
                        >
                            <div className="flex items-center gap-3">
                                Notre Ambition
                            </div>
                        </button>
                    </div>
                </AnimatedSection>

                <AnimatedSection delay={0.4}>
                    <motion.div
                        key={activeTab}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="relative"
                    >
                        <div className="relative bg-gray-900/50 backdrop-blur-xl rounded-2xl p-8 md:p-12 border border-gray-700 shadow-xl">
                            {activeTab === "mission" ? (
                                <div className="flex flex-col items-center text-center">
                                    <div className="w-20 h-20 rounded-2xl bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center mb-8">
                                        <Target className="w-10 h-10 text-white" />
                                    </div>

                                    <h3 className="text-3xl font-bold text-white mb-6">Notre Mission</h3>
                                    <p className="text-xl text-gray-300 max-w-3xl leading-relaxed">
                                        Nous sommes un acteur global des technologies de l'information. Notre mission est d'accompagner nos clients dans l'atteinte de leurs objectifs stratégiques et opérationnels grâce aux solutions digitales.
                                    </p>
                                </div>
                            ) : (
                                <div className="flex flex-col items-center text-center">
                                    <div className="w-20 h-20 rounded-2xl bg-gradient-to-r from-blue-500  flex items-center justify-center mb-8">
                                        <Rocket className="w-10 h-10 text-white" />
                                    </div>
                                    <h3 className="text-3xl font-bold text-white mb-6">Notre Ambition</h3>
                                    <p className="text-xl text-gray-300 max-w-3xl leading-relaxed">
                                        En tant que partenaire de confiance, nous souhaitons avoir un impact positif sur la société en démocratisant l'usage des nouvelles technologies au service de l'efficacité business, du développement durable et de l'inclusion sociale.
                                        Notre ambition pour les 20 prochaines années est de devenir le partenaire technologique de référence des entreprises les plus innovantes à l'international en leur apportant les solutions sur-mesure les plus avancées qui feront leur succès dans un monde digitalisé.
                                    </p>
                                </div>
                            )}
                        </div>
                    </motion.div>
                </AnimatedSection>
            </div>
        </section>
    );
};

export default VisionSection;
